import { createSelector } from 'reselect';
import { ICategoriesState } from './types';

export const selectAllPaths = (state: ICategoriesState) => state.paths;
export const selectCategories = (state: ICategoriesState) => state.categories;
export const selectChildrenMap = (state: ICategoriesState, nodeId) => state.nodes;
export const selectChildren = (state: ICategoriesState, nodeId) => state.nodes[nodeId];
export const selectSyncError = (state: ICategoriesState) => state.error;
export const selectSyncState = (state: ICategoriesState, nodeId) =>
  !!(nodeId ? state.syncingNodes[nodeId] : state.syncing);

export const selectPaths = createSelector(
  [selectAllPaths, (_: ICategoriesState, nodeIds: Array<string>) => nodeIds],
  (paths, ids) => ids.map((id) => paths[id]).filter(Boolean)
);
